import { Course } from '../../types';
import { regexModule1 } from '../modules/regexModule1';
import { regexModule2 } from '../modules/regexModule2';
import { regexModule3 } from '../modules/regexModule3';
import { regexModule4 } from '../modules/regexModule4';
import { regexModule5 } from '../modules/regexModule5';

export const regexCourse: Course = {
  id: 'regex-learning',
  title: 'Regular Expressions Mastery',
  description:
    'Master the art of pattern matching with regular expressions. From basic literal matching to advanced lookarounds and real-world applications, this comprehensive course covers everything you need to become a regex expert.',
  category: 'programming',
  difficulty: 'intermediate',
  estimatedHours: 15,
  prerequisites: ['basic-programming'],
  tags: ['regex', 'patterns', 'text-processing', 'validation', 'data-extraction', 'python'],
  thumbnail: '/images/regex-course.png',
  modules: [regexModule1, regexModule2, regexModule3, regexModule4, regexModule5],
  tools: {
    playground: true,
    reference: true,
  },
};
